<template lang="">
    <div>

   <li v-if="!isDisabled" @click="showModalNovo()" >Novo</li>

    <!-- <b-button
    v-if="!isDisabled"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="outline-primary"
        class="btn-icon"
        >
        <feather-icon icon="SearchIcon" />
    </b-button> -->

        <b-modal v-model="show" title="Estabelecimento" hide-footer>
      <form>
        <div class="form-group">
          <label>Nome</label>
          <input
    
            type="text"
            class="form-control"
            v-model="estabelecimento.name"
            :disabled="isDisabled"
          />
        </div>
        <div class="form-group">
          <label>CNPJ</label>
          <input
            type="text"
            class="form-control"
            v-model="estabelecimento.cnpj"
            :disabled="isDisabled"
          />
        </div>
        <div class="form-group">
          <label>Email</label>
          <input
            type="text"
            class="form-control"
            v-model="estabelecimento.email"
            :disabled="isDisabled"
          />
        </div>
        <div v-if="!isDisabled" class="form-group">
          <label>Responsavél</label>
          <input
          
            type="text"
            class="form-control"
            v-model="estabelecimento.responsible"
            :disabled="isDisabled"
          />
        </div>
        <div v-if="isDisabled" class="form-group">
          <label>ApiKey</label>
          <input
          
            type="text"
            class="form-control"
            v-model="estabelecimento.apiKey"
            :disabled="isDisabled"
          />
        </div>
        <div class="text-center">

          <b-button variant="gradient-dark "
           v-if="!spiner"
            
             @click="SalvarEstabelecimento()"
            >
              Salvar
          </b-button>
       
          <b-button
          v-if="spiner"
              variant="gradient-dark"
              disabled
              class="mr-1"
            >
              <b-spinner small />
              Salvando
          </b-button>
          
        </div>
      </form>
    </b-modal>
        
    </div>
</template>
<script>
import { BButton } from 'bootstrap-vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
    components: {
    BButton,
  },
 
    data() {
        return {
            status: "",
            password: "",
            show: false,
            isDisabled: false,
            spiner:false,

            estabelecimento: {
                name: null,
                cnpj: null,
                id: null,
                email: null,
                apiKey: null,
                responsible:null
            },
        }
    },

    created() {
  
      },
  computed: {
    usuario() {
      return this.$store.state.login.usuario;
    },
    lista_estabelecimentos() {
      return this.$store.state.estabelecimentos.lista_estabelecimentos.data;
    },
    mensagem_alert() {
      return this.$store.state.configEmpresa.mensagem_alert;
    },
  },

  methods: {
  async  SalvarEstabelecimento(){
    this.spiner =  true
      const dados = {
         name: this.estabelecimento.name,
         cnpj: this.estabelecimento.cnpj,
         email: this.estabelecimento.email,
         company_id: this.usuario.companyId,
         responsible:this.estabelecimento.responsible
      }

       console.log(dados)

      await this.$store
        .dispatch("estabelecimentos/cadastrar", dados)
        .then((data) => {
           
            this.$store.dispatch("estabelecimentos/all_estabelecimentos");
            this.$toast({
            component: ToastificationContent,
            props: {
              title: "Salvo com sucesso",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.show = false
          this.spiner = false
         
        })
        .catch((error) => {
         
          this.spiner = false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro:" + error,
              icon: "EditIcon",
              variant: "danger",
            },
          });
        
         
        });
      
     
    },
    showModalSenha(item) {
      this.isDisabled = true;
      this.estabelecimento = {
        id: item.id,
        name: item.name,
        cnpj: item.cnpj,
        email: item.email,
        apiKey: item.apiKey,
      };
      this.show = true;
    },
    showModalNovo() {
      this.estabelecimento = {
        id: null,
        name: null,
        cnpj: null,
        email: null,
        apiKey: null,
      };
    //   this.isDisabled = false;
      this.show = true;
    },
  },
};
</script>
    
<style lang="">
    
</style>